import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';

import { CUSTOM_ERROR_HANDLERS } from '@abp/ng.theme.shared';

import { NexAbpAuthenticationErrorHandler } from './nex-abp-authentication-error.handler';
import { NexRefreshAuthTokenInterceptor } from './nex-refresh-auth-token.interceptor';

export function provideNexRefreshTokenOverrides() {
  const providers = [
    {
      provide: CUSTOM_ERROR_HANDLERS,
      multi: true,
      useExisting: NexAbpAuthenticationErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NexRefreshAuthTokenInterceptor,
      multi: true,
    },
  ];

  return makeEnvironmentProviders(providers);
}
